import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { GroupsScreen } from '@/screens/groups/GroupsScreen';
import { GroupChatScreen } from '@/screens/chat/GroupChatScreen';
import { StockChatScreen } from '@/screens/stock/StockChatScreen';
import { StockAnalysisScreen } from '@/screens/stock/StockAnalysisScreen';
import { StockDetailScreen } from '@/screens/stock/StockDetailScreen';
import CollaborativeChartScreen from '@/screens/charts/CollaborativeChartScreen';
import { GroupsStackParamList } from './types';

const Stack = createStackNavigator<GroupsStackParamList>();

/**
 * Groups Stack Navigator
 * Handles navigation between groups list, group chats, stock analysis, and collaborative charts
 */
export const GroupsNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="GroupsList" component={GroupsScreen} />
      <Stack.Screen name="GroupChat" component={GroupChatScreen} />
      <Stack.Screen name="StockChat" component={StockChatScreen} />
      <Stack.Screen name="StockAnalysis" component={StockAnalysisScreen} />
      <Stack.Screen name="StockDetail" component={StockDetailScreen} />
      <Stack.Screen
        name="CollaborativeChart"
        component={CollaborativeChartScreen}
        options={{
          presentation: 'modal',
          animation: 'slide_from_bottom',
        }}
      />
    </Stack.Navigator>
  );
};
